export const getQueryStringParameterValue = (key) => {
  if (!window.location.search) return undefined

  const params = (
    /^[?#]/.test(window.location.search)
      ? window.location.search.slice(1)
      : window.location.search
  )
    .split('&')
    .reduce((parameters, param) => {
      let [keyIndex, value] = param.split('=')
      if (keyIndex === 'width' || keyIndex === 'height') {
        value = value.replace('%', '%25')
      }
      parameters[keyIndex] = value
        ? decodeURIComponent(value.replace(/\+/g, ' '))
        : ''
      return parameters
    }, {})

  if (!params || Object.keys(params).length < 1) return undefined

  return params[key]
}
// convert DD/MM/YYYY to YYYY-MM-DD
export const dateFormatForSecFiling = (date) => {
  return date.split('/').reverse().join('-')
}
export const getAccessToken = () => {
  let accessToken = ''
  const queryParamToken = getQueryStringParameterValue('token')
  if (queryParamToken) {
    accessToken = queryParamToken
  } else {
    accessToken = getCookie('MODJSONWebToken')
  }
  return accessToken
}

export const getCookie = (cname) => {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

// formatting date in like January 1st 2000
export const calDateFormatter = (date) => {
  let newDate = new Date(date) // send date in yyyy-mm-dd format
  return `${monthNames[newDate.getMonth()]} ${ordinalSuffix(newDate.getDate())} ${newDate.getFullYear()}`
}

export const ordinalSuffix = (i) => { // st, nd, rd, th suffix
  let j = i % 10
  let k = i % 100
  if (j === 1 && k !== 11) {
    return i + 'st'
  }
  if (j === 2 && k !== 12) {
    return i + 'nd'
  }
  if (j === 3 && k !== 13) {
    return i + 'rd'
  }
  return i + 'th'
}

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

export const marketExchangeRatesList = [
  {
    wsodIssue: '616278',
    symbol: 'AUD / CHF'
  },
  {
    wsodIssue: '34048323',
    symbol: 'AUD / CNY'
  },
  {
    wsodIssue: '611513',
    symbol: 'AUD / EUR'
  },
  {
    wsodIssue: '619566',
    symbol: 'AUD / GBP'
  },
  {
    wsodIssue: '611390',
    symbol: 'AUD / HKD'
  },
  {
    wsodIssue: '618341',
    symbol: 'GBP / USD'
  },
  {
    wsodIssue: '617254',
    symbol: 'EUR / USD'
  },
  {
    wsodIssue: '620004',
    symbol: 'AUD / INR'
  },
  {
    wsodIssue: '613892',
    symbol: 'AUD / JPY'
  },
  {
    wsodIssue: '610560',
    symbol: 'AUD / NZD'
  },
  {
    wsodIssue: '613439',
    symbol: 'AUD / SGD'
  },
  {
    wsodIssue: '612460',
    symbol: 'AUD / USD'
  },
  {
    wsodIssue: '616660',
    symbol: 'USD / JPY'
  },
  {
    wsodIssue: '617621',
    symbol: 'EUR / JPY'
  }
]

export const createSecFilingLink = (documentKey, feedId, versionTag, docType, accessToken) => {
  return `${window.MD.COMSEC_CDN_API_URL}${window.MD.COMSEC_BASE_URL}/getDocument?feedID=${feedId}&documentTag=${documentKey}&documentType=${docType}&versionTag=${versionTag}&access_token=${accessToken}`
}

export const companyPerfDropdowns = (disableintl = false) => {
  const defaultValues = [
    {
      label: 'ranked-by',
      items: [
        { value: 'Most Actives' },
        { value: 'Advancers' },
        { value: 'Decliners' }
      ],
      selectedItemIndex: 0
    },
    {
      label: 'size-buckets',
      items: [
        { value: 'All Cap' },
        { value: 'Large Cap' },
        { value: 'Mid Cap' },
        { value: 'Small Cap' }
      ],
      selectedItemIndex: 0
    }
  ]

  return disableintl
    ? defaultValues
    : [
        {
          label: 'markets',
          items: [
            { value: 'US Exchanges' },
            { value: 'FTSE 100' }
          ],
          selectedItemIndex: 0
        },
        ...defaultValues
      ]
}

export const getRankingSet = (
  rankingSet,
  market = 'CommSec',
  disableintl = false
) => {
  const USRankSetName = 'US Composite Equities'
  const LSERankSetName = 'LSE Equities'

  const rankSetText = (RanksetName, rankingSet) => {
    if (['Small Cap', 'Mid Cap', 'Large Cap'].includes(rankingSet)) {
      let queryParamTxt = disableintl
        ? `${RanksetName} ${rankingSet.replaceAll(' ', '')}`
        : RanksetName + ' - ' + rankingSet
      return queryParamTxt
    }
    // exception: 'US Composite Equities' to 'US Composite Stocks' conversion
    if (RanksetName === 'US Composite Equities') { RanksetName = 'US Composite Stocks' }
    return disableintl ? 'CommSec All MarketCap' : RanksetName
  }

  if (market === 'FTSE 100') {
    return rankSetText(LSERankSetName, rankingSet)
  } else if (market === 'US Exchanges') {
    return rankSetText(USRankSetName, rankingSet)
  }
  return rankSetText(market, rankingSet)
}

export const getRankingType = (rankingType) => {
  switch (rankingType) {
    case 'Most Actives':
      return 'MostActive'
    case 'Advancers':
      return 'PctChgGainers'
    case 'Decliners':
      return 'PctChgLosers'
    default:
      return 'MostActive'
  }
}

export const getDirectionColor = (value) => {
  if (value > 0) return 'pos'
  if (value < 0) return 'neg'
  return 'unchanged'
}

export const numberWithCommas = (num, decimal) => {
  return num.toLocaleString('en-US', { maximumFractionDigits: decimal, minimumFractionDigits: decimal })
}

export const exchanges = ['LME', 'NYMEX', 'COMEX']

export const commoditiesList = [
  {
    companyName: 'Silver',
    exchangeCode: 'COMEX',
    xid: '1045598'
  },
  {
    companyName: 'Gold',
    exchangeCode: 'COMEX',
    xid: '1045492' },
  {
    companyName: 'Copper',
    exchangeCode: 'COMEX',
    xid: '1046328'
  },
  {
    companyName: 'Aluminium',
    exchangeCode: 'LME',
    xid: '46613419'
  },
  {
    companyName: 'Nickel',
    exchangeCode: 'LME',
    xid: '46613425'
  },
  {
    companyName: 'Lead',
    exchangeCode: 'LME',
    xid: '46613428' },
  {
    companyName: 'Tin',
    exchangeCode: 'LME',
    xid: '46613431'
  },
  {
    companyName: 'Zinc',
    exchangeCode: 'LME',
    xid: '46613433'
  },
  {
    companyName: 'Palladium',
    exchangeCode: 'NYMEX',
    xid: '18483223'
  },
  {
    companyName: 'Platinum',
    exchangeCode: 'NYMEX',
    xid: '18366493'
  },
  {
    companyName: 'WTI',
    exchangeCode: 'NYMEX',
    xid: '1070572'
  },
  {
    companyName: 'Iron Ore',
    exchangeCode: 'NYMEX',
    xid: '27110161'
  }
]
